import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

//import { Room } from '@/models'

export default {
  namespaced: true,
  state: {
    //room: null,
    transcript: [],
    transcriptSettings: {background: '#ffffff', color: '#333333', size: 12, captionsOnly: false, justify: 'flex-start'}
  },
  mutations: {
    /*clearRoom (state) {
      state.room = null
    },*/
    /*setRoom (state,payload) {
      state.room = payload.room
    },*/
    clearTranscript (state) {
      state.transcript = []
    },
    addMessage (state,payload) {
      state.transcript.push(payload.message)
    },
    setTranscriptSettings(state,payload){
      for (let [key, value] of Object.entries(payload.settings)) {
        state.transcriptSettings[key] = value
      }
    }
  },
  actions: {
    reset({commit}) {
      //commit('clearRoom');
      commit('clearTranscript');
    },
    /*joinRoom({commit},payload) {
      let room = new Room();
      room.name = payload.name;
      commit('setRoom',{room: room});
      commit('clearTranscript');
    },*/
    /*leaveRoom({commit}) {
      commit('setRoom',{room: null});
    },*/
    setTranscript({commit},payload) {
      commit('clearTranscript')
      payload.transcript.forEach((message) => {
        commit('addMessage', {message: message})
      });
    },
    addMessage({commit},payload){
      commit('addMessage',payload)
      var payloadExtension = Object.assign({},payload)
      payloadExtension.name = "addMessage"
      window.postMessage(payloadExtension, window.location.origin)
    },
  },
  getters: {
    getCaptions: (state) => {
      return state.transcript.filter(m => !m.notice)
    },
  },
}
